// Copyright (c) 2021 WiseTime. All rights reserved.

import { combineEpics } from "redux-observable"
import batchGetTags from "./batchGetTags"
import batchGetTagCategories from "./batchGetTagCategories"
import fetchRecentTags from "./fetchRecentTags"
import fetchFavouriteTags from "./fetchFavouriteTags"
import searchTags from "./searchTags"
import updateTag from "./updateTag"
import createFavouriteTag from "./createFavouriteTag"
import deleteFavouriteTag from "./deleteFavouriteTag"
import reorderFavouriteTag from "./reorderFavouriteTag"
import loadOrderBy from "./loadOrderBy"
import loadRecentOrderBy from "./loadRecentOrderBy"
import persistOrderBy from "./persistOrderBy"
import createTagKeyword from "./createTagKeyword"
import deleteTagKeyword from "./deleteTagKeyword"
import getTag from "./getTag"
import persistRecentOrderBy from "./persistRecentOrderBy"
import persistViewMode from "./persistViewMode"
import searchTagsShallow from "./searchTagsShallow"
import loadViewMode from "./loadViewMode"
import listTagsByCategory from "./listTagsByCategory"
import getTagCategory from "./getTagCategory"
import { Action } from "redux"
import type { RootState } from "../../../app/store"

export default combineEpics<Action, Action, RootState, unknown>(
  batchGetTags,
  batchGetTagCategories,
  searchTags,
  searchTagsShallow,
  fetchRecentTags,
  updateTag,
  fetchFavouriteTags,
  createFavouriteTag,
  deleteFavouriteTag,
  reorderFavouriteTag,
  loadOrderBy,
  loadRecentOrderBy,
  loadViewMode,
  persistOrderBy,
  persistRecentOrderBy,
  persistViewMode,
  createTagKeyword,
  deleteTagKeyword,
  getTag,
  listTagsByCategory,
  getTagCategory,
)
